module.exports = __webpack_public_path__ + "img/recharge.d994aefb.svg";